///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/decorators.ts" />
///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/providers/settings.ts" />
namespace TotalPoll {
    import Controller = TotalCore.Common.Controller;
    import SettingsService = TotalCore.Common.Providers.SettingsService;
    // @ts-ignore
    import ILocationService = angular.ILocationService;
    // @ts-ignore
    import TabService = TotalCore.Common.Providers.TabService;

    @Controller('controllers.totalpoll')
    // @ts-ignore
    export class EditorCtrl {
        public information = this.SettingsService.information;
        public languages = this.SettingsService.languages;
        public modules = this.SettingsService.modules;
        public settings = this.SettingsService.settings;
        public presets = this.SettingsService.presets;

        constructor(private $rootScope, private SettingsService: SettingsService, private $location: ILocationService, private TabService: TabService) {
            let urlParams = this.$location.search();
            if (!this.settings.expressions || angular.isArray(this.settings.expressions)) {
                this.settings.expressions = {};
            }
            $rootScope.settings = this.settings;
            $rootScope.information = this.information;
            $rootScope.modules = this.modules;
            $rootScope.languages = this.languages;

            $rootScope.$applyAsync(() => {
                if (!urlParams.tab) {
                    TabService.set('editor', 'questions');
                }
            });



        }

        prepareExpression(languageCode, rawExpression){
            if(!this.settings.expressions[languageCode]){
                this.settings.expressions[languageCode] = {}
            }
            
            if(!this.settings.expressions[languageCode][rawExpression]){
                
                this.settings.expressions[languageCode][rawExpression] = {'translations': []}
            }
            return this.settings.expressions[languageCode][rawExpression];
        }

        setTimeout(timeout) {
            this.$rootScope.settings.vote.frequency.timeout = parseInt(timeout, 10);
        }

        isCustomTimeout() {
            return ! (this.$rootScope.settings.vote.frequency.timeout in this.presets.timeout);
        }
    }

}